import { useAtParentIndex, useParent } from '../utils/components';
import { ROW_BIND_COL_KEY, ROW_COUNT_COL_KEY } from '../row/provide';
export function useRow() {
  var {
    parentProvider,
    bindParent
  } = useParent(ROW_BIND_COL_KEY);
  var {
    index
  } = useAtParentIndex(ROW_COUNT_COL_KEY);

  if (!parentProvider || !bindParent || !index) {
    console.warn('col must in row');
  }

  return {
    index,
    row: parentProvider,
    bindRow: bindParent
  };
}